import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Avatar, Badge, Breadcrumb, Button, Card, Col, Descriptions, Divider, Row, Upload } from 'antd';
import { OptionEcole } from './options-ecole';
import { deleteLogo, getEcole, getLogo, uploadLogo } from './ecole.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { BankOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';
import './ecole.scss';

export const EcoleDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const ecoleId = props.match.params.id;

  useEffect(() => {
    dispatch(getEcole(ecoleId));
    dispatch(getLogo(ecoleId));
  }, [dispatch, ecoleId]);

  const ecoleEntity = useAppSelector(state => state.ecole.entity);
  const ecoleLogo = useAppSelector(state => state.ecole.logo);
  const account = useAppSelector(state => state.authentication.account);

  const canManageLogo = hasAnyAuthority(account.authorities, [AUTHORITIES.ADMIN, AUTHORITIES.DIRECTEUR, AUTHORITIES.DIRECTEUR_ETUDE]);

  const handleLogoUpload = {
    beforeUpload(file) {
      const formData = new FormData();
      formData.append('file', file);
      dispatch(uploadLogo({ id: ecoleId, file: formData }));
      return false;
    },
  };

  const handleDeleteLogo = () => {
    dispatch(deleteLogo(ecoleId));
  };

  return (
    <>
      <Breadcrumb className="p-4">
        <Breadcrumb.Item>
          <a href="/">{ecoleEntity.nom}</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a href="/ecole">Ecoles</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a href={`ecole/${ecoleEntity.id}/details`}>Details</a>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card>
        <Row className="justify-content-center">
          <Col lg={{ span: 6 }} xs={{ span: 24 }} sm={{ span: 8 }} md={{ span: 5 }} className="p-4">
            <Descriptions>
              <Descriptions.Item>
                {canManageLogo ? (
                  <Upload {...handleLogoUpload} showUploadList={false} className="ecole-logo-upload" accept="image/png,image/jpeg">
                    <Badge.Ribbon className="ecole-logo-badge" color="cyan" text={<EditOutlined />}>
                      <Avatar
                        shape="square"
                        src={ecoleLogo || undefined}
                        size={{ xs: 80, sm: 100, md: 100, lg: 120, xl: 150, xxl: 100 }}
                        icon={<BankOutlined />}
                      />
                    </Badge.Ribbon>
                  </Upload>
                ) : (
                  <Avatar
                    shape="square"
                    src={ecoleLogo || undefined}
                    size={{ xs: 80, sm: 100, md: 100, lg: 120, xl: 150, xxl: 100 }}
                    icon={<BankOutlined />}
                  />
                )}
              </Descriptions.Item>
            </Descriptions>
          </Col>

          <Divider type="vertical" style={{ height: 'auto' }} />
          <Col lg={{ span: 10 }} xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 9 }}>
            <h2 style={{ textAlign: 'center' }} className="p-2">
              {' '}
              {ecoleEntity.nom}{' '}
            </h2>
            <span>
              <Descriptions column={1}>
                <Descriptions.Item label="Adresse">{ecoleEntity.adresse}</Descriptions.Item>
                <Descriptions.Item label="Email">{ecoleEntity.email}</Descriptions.Item>
                <Descriptions.Item label="Téléphone">{ecoleEntity.telephone}</Descriptions.Item>
              </Descriptions>
            </span>
          </Col>

          <Divider type="vertical" style={{ height: 'auto' }} />
          <Col lg={{ span: 4 }} xs={{ span: 24 }} md={{ span: 8 }} sm={{ span: 8 }} style={{ textAlign: 'center' }}>
            <OptionEcole {...props} />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default EcoleDetail;
